
import CardShowcaseSection from '@/components/CardShowcaseSection';
import Hero from '@/components/Hero';
import ImageMasonryGrid from '@/components/ImageMasonryGrid';
import MultiCenterHolidays from '@/components/MultiCenterHolidays';
import OfferGrid from '@/components/OfferGrid';
import { popularDestinationsData } from '@/data/popularDestinationData';
import { yachtTypes } from '@/data/yachtTypesData';
import { useScrollToHash } from "@/hooks/useScrollToHash";
import { heroSlidesData } from '@/data/heroSlidesData';
import { useEffect, useState } from 'react';

export default function Main() {
    useScrollToHash();
    const [heroSlides, setHeroSlides] = useState(heroSlidesData);

    useEffect(() => {
        const updatedSlides = [...heroSlidesData];
        setHeroSlides(updatedSlides);
    }, heroSlidesData);
    return (
        <div className="main">
            <Hero
                useCarouselDefaultText={true}
                key={new Date().getTime()} />
            <OfferGrid />
            <ImageMasonryGrid
                sectionId="discover"
                sectionSubtitle="Discover"
                sectionTitle="Sail Your Wanderlust"
                sectionAnnotation="Distinctive destinations, selected for unforgettable yachting experiences"
                items={popularDestinationsData.map((item) => ({
                    image: item.image,
                    imageText: item.imageText,
                    alt: item.alt,
                    subtitle: item.cardTitle,
                    link: item.link,
                }))}
            />
            <CardShowcaseSection
                sectionData={
                    {
                        sectionId: "yachtCollections",
                        sectionSubtitle: "Yacht Collections",
                        sectionTitle: "Every Style, Every Sea",
                        sectionAnnotation: "From sleek catamarans to classic motor yachts – find your perfect way to sail",
                        items: yachtTypes.map((item) => ({
                            image: item.image,
                            imageText: '',
                            alt: item.title,
                            cardTitle: item.title,
                            link: item.link ?? '/',
                            price: item.price,
                        })),
                    }
                }
            />
            <MultiCenterHolidays />
            <section></section>
        </div>
    );
}